export const ClientsTableColumns = (isArabic) => [
    { id: 'name', label: isArabic ? 'الاسم' : 'Name', align: 'start' },
    { id: 'logo', label: isArabic ? 'الشعار' : 'Logo', align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' }
];